





















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils';
import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import { CreateTicketRequestDto } from '@/api/interfaces/create-ticket-request.interface';
import { TicketType } from '@/api/enums/ticket-type.enum';
import TextInput from '@/components/TextInput/TextInput.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import SelectorAndList from '@/components/organisms/Views/admin/flags/SelectorAndList.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import DatePicker from '@/components/DatePicker/DatePicker.vue';

interface ICustomer {
  id: string;
  label?: string;
  name: string;
  lastname: string;
  mail: string;
}

interface AddTicketFormData {
  customers: ICustomer[];
  requestDeletionDate: Date | null;
  keepAddingTicket: boolean;
}

@Component({
  components: {
    TextInput,
    FormLabel,
    FilledButton,
    SelectorAndList,
    Checkbox,
    DatePicker
  }
})
export default class TicketRequestDeleteCustomer extends Vue {
  @Prop() readonly data!: any;

  loading = false;
  adminService = new AdminService();

  customersOptions: ICustomer[] = [];
  datepickerPlaceholder: string = 'Date';

  form: AddTicketFormData = {
    customers: [],
    requestDeletionDate: null,
    keepAddingTicket: false
  };

  created() {}

  async searchCustomers(search: string) {
    try {
      const { data } = await this.adminService.searchCustomers(search);
      const selectedIds = new Set(this.form.customers.map(c => c.id));

      this.customersOptions = this.mapCustomers(
        data.items
          .map(({ customer }: any) => customer)
          .filter((item: any) => !selectedIds.has(item.id))
      );
    } catch (e) {
      this.customersOptions = [];
      this.$notification(treatError(e));
    }
  }

  mapCustomers(customers: ICustomer[] = []) {
    return customers.map(customer => {
      return {
        label: `${customer.name} ${customer.lastname} (${customer.mail})`,
        ...customer
      };
    });
  }

  async updateRequestDeletionDate(date: string) {
    this.datepickerPlaceholder = DateUtils.formattedDate({
      date
    });

    this.form.requestDeletionDate = new Date(date);
  }

  async updateKeepAddingTicket() {
    this.form.keepAddingTicket = !this.form.keepAddingTicket;
  }

  async resetForm() {
    this.form.customers = [];
    this.form.requestDeletionDate = null;
    this.datepickerPlaceholder = 'Date';
  }

  async requestDeletion() {
    try {
      this.loading = true;

      const [customer] = this.form.customers;

      if (!customer) {
        this.$notification(
          'Action Required: Select a customer for deletion.',
          'error'
        );
        return;
      }

      if (!this.form.requestDeletionDate) {
        this.$notification(
          'Action Required: Select the date that the user requested deletion.',
          'error'
        );
        return;
      }

      const data: CreateTicketRequestDto = {
        type: TicketType.DeleteCustomer,
        message: `Delete customer ${customer.mail}`,
        requestedAt: this.form.requestDeletionDate,
        parameters: {
          id: customer.id
        }
      };

      const response = await this.adminService.createTicketRequest(data);

      this.$notification(
        "Customer deletion request initiated successfully. We're processing your request."
      );

      if (!this.form.keepAddingTicket) {
        return this.closeModal();
      }

      this.resetForm();
    } catch (e) {
      this.$notification(treatError(e));
    } finally {
      this.loading = false;
    }
  }

  closeModal() {
    eventBus.$emit('setSideModalVisible', false);
  }
}
